// src/components/ContactForm.jsx
import React, { useState } from "react";

export const ContactForm = ({ onSubmit, buttonText = "Let's Talk!" }) => {
  const [formData, setFormData] = useState({
    festivalName: "",
    contactPerson: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    /* FUNCTION TO SHOW SUMITTED DATA FROM FORM  - START - */
    const logFormData = (data) => {
      alert(
        "Festival Name: " +
          data.festivalName +
          "\nContact Name: " +
          data.contactPerson +
          "\nEmail Name: " +
          data.email +
          "\nSubmission Message: " +
          data.message +
          "\nSubmission Time: " +
          new Date().toLocaleString()
      );
      console.group("Data from Form");
      console.log("Festival Name:", data.festivalName);
      console.log("Contact Person:", data.contactPerson);
      console.log("Email:", data.email);
      console.log("Message:", data.message);
      console.log("Submission Time:", new Date().toLocaleString());
      console.groupEnd();
    };
    /* FUNCTION TO SHOW SUMITTED DATA FROM FORM  - END - */

    try {
      logFormData(formData);

      if (onSubmit) {
        await onSubmit(formData);
      }

      //Clear after successfully submitted
      setFormData({
        festivalName: "",
        contactPerson: "",
        email: "",
        message: "",
      });

      setStatus({
        type: "success",
        message:
          "Message sent successfully! See console for submitted inputs - modify logFormData @ ContactForm.jsx",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: "Failed to send message.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6"  id="contact-us">
      <div>
        <label className="block text-sm font-medium mb-2 text-gray-300">
          Festival Name
        </label>
        <input
          type="text"
          name="festivalName"
          value={formData.festivalName}
          onChange={handleChange}
          className="w-full px-4 py-3 bg-black/20 border border-[#FF4D00]/20 rounded-lg focus:outline-none focus:border-[#FF4D00] transition text-white"
          placeholder="Enter your festival name"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-gray-300">
          Contact Person
        </label>
        <input
          type="text"
          name="contactPerson"
          value={formData.contactPerson}
          onChange={handleChange}
          className="w-full px-4 py-3 bg-black/20 border border-[#FF4D00]/20 rounded-lg focus:outline-none focus:border-[#FF4D00] transition text-white"
          placeholder="Your name"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-gray-300">
          Email Address
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-4 py-3 bg-black/20 border border-[#FF4D00]/20 rounded-lg focus:outline-none focus:border-[#FF4D00] transition text-white"
          placeholder="you@example.com"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-gray-300">
          Message
        </label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="w-full px-4 py-3 bg-black/20 border border-[#FF4D00]/20 rounded-lg focus:outline-none focus:border-[#FF4D00] transition text-white h-32"
          placeholder="Tell us about your festival and what you're looking for"
          required
        ></textarea>
      </div>

      {status && (
        <div
          className={`p-4 rounded-lg ${
            status.type === "success"
              ? "bg-green-500/10 text-green-400"
              : "bg-red-500/10 text-red-400"
          }`}
        >
          {status.message}
        </div>
      )}

      <button
        type="submit"
        className="w-full bg-[#FF4D00] hover:bg-[#FF6B00] px-8 py-4 rounded-lg text-lg font-semibold transition relative"
        disabled={loading}
      >
        {loading ? (
          <span className="flex items-center justify-center">
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Sending...
          </span>
        ) : (
          buttonText
        )}
      </button>
    </form>
  );
};

export default ContactForm;
